const IMAGE_QUERY_PARAMS = '?w=300&bg=F5F6F7&fm=jpeg&auto=format';

export { IMAGE_QUERY_PARAMS };
//# sourceMappingURL=constants.js.map
